package com.sddamico.swigmore.util

/**
 * The lifecycle of an async resource fetched from the API. Pages hold one of these in a
 * `mutableStateOf` and branch on it when rendering.
 */
sealed class LoadState<out T> {
  object Loading : LoadState<Nothing>()
  data class Ready<out T>(val value: T) : LoadState<T>()
  data class Failed(val message: String) : LoadState<Nothing>()
}
